exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_view .card[data-v-2109238f]{min-height:190px}", ""]);

// exports
